var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9993 23.3333H4.99935C3.16102 23.3333 1.66602 21.8383 1.66602 20V3.33333C1.66602 1.495 3.16102 0 4.99935 0H34.9993C36.8377 0 38.3327 1.495 38.3327 3.33333V20C38.3327 21.8383 36.8377 23.3333 34.9993 23.3333ZM4.99935 1.66667C4.07935 1.66667 3.33268 2.415 3.33268 3.33333V20C3.33268 20.9183 4.07935 21.6667 4.99935 21.6667H34.9993C35.9193 21.6667 36.666 20.9183 36.666 20V3.33333C36.666 2.415 35.9193 1.66667 34.9993 1.66667H4.99935Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9994C19.7864 39.9994 19.5731 39.9177 19.4098 39.7561L14.4098 34.7561C14.0848 34.4311 14.0848 33.9027 14.4098 33.5777C14.7348 33.2527 15.2631 33.2527 15.5881 33.5777L19.9998 37.9877L24.4098 33.5777C24.7348 33.2527 25.2631 33.2527 25.5881 33.5777C25.9131 33.9027 25.9131 34.4311 25.5881 34.7561L20.5881 39.7561C20.4264 39.9177 20.2131 39.9994 19.9998 39.9994Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 40C19.5393 40 19.166 39.6267 19.166 39.1667V25.8333C19.166 25.3733 19.5393 25 19.9993 25C20.4593 25 20.8327 25.3733 20.8327 25.8333V39.1667C20.8327 39.6267 20.4593 40 19.9993 40Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 18.3333C16.324 18.3333 13.334 15.3433 13.334 11.6667C13.334 7.99 16.324 5 20.0006 5C23.6773 5 26.6673 7.99 26.6673 11.6667C26.6673 15.3433 23.6773 18.3333 20.0006 18.3333ZM20.0006 6.66667C17.244 6.66667 15.0006 8.91 15.0006 11.6667C15.0006 14.4233 17.244 16.6667 20.0006 16.6667C22.7573 16.6667 25.0006 14.4233 25.0006 11.6667C25.0006 8.91 22.7573 6.66667 20.0006 6.66667Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16601 12.5007H7.49935C7.03935 12.5007 6.66602 12.1273 6.66602 11.6673C6.66602 11.2073 7.03935 10.834 7.49935 10.834H9.16601C9.62601 10.834 9.99935 11.2073 9.99935 11.6673C9.99935 12.1273 9.62601 12.5007 9.16601 12.5007Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 12.5007H30.8333C30.3733 12.5007 30 12.1273 30 11.6673C30 11.2073 30.3733 10.834 30.8333 10.834H32.5C32.96 10.834 33.3333 11.2073 33.3333 11.6673C33.3333 12.1273 32.96 12.5007 32.5 12.5007Z",
    fill: "#8DDCA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.425bcf6e022b42230806acbecde6e21e.svg";
export { ForwardRef as ReactComponent };